import React from 'react';
import type { AuthorizationSberIdFormHOCInfoProps } from './AuthorizationSberIdFormHOCInfo.types';
import Styles from './AuthorizationSberIdFormHOCInfo.scss';

export const AuthorizationSberIdFormHOCInfo = ({
  text
}: AuthorizationSberIdFormHOCInfoProps) => (
  <div className={Styles.info}>{text}</div>
);
